import { render } from "./VrTour.vue?vue&type=template&id=f46b195a&scoped=true"
import script from "./VrTour.vue?vue&type=script&lang=js"
export * from "./VrTour.vue?vue&type=script&lang=js"

import "./VrTour.vue?vue&type=style&index=0&id=f46b195a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f46b195a"

export default script